// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_b1-4";
export var collapsed = "_b1-1";
export var headerBar = "_b1-0";
export var leftHeaderContent = "_b1-3";
export var subjectContainer = "_b1-2";